import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { SpecialOffer } from "@/components/landing/SpecialOffer";
import { Services } from "@/components/landing/Services";
import { WhyAFZ } from "@/components/landing/WhyAFZ";
import { SlowPC } from "@/components/landing/SlowPC";
import { ScreenRepair } from "@/components/landing/ScreenRepair";
import { Upgrades } from "@/components/landing/Upgrades";
import { Extras } from "@/components/landing/Extras";
import { RefurbishedStock } from "@/components/landing/RefurbishedStock";
import { Malware } from "@/components/landing/Malware";
import { Problems } from "@/components/landing/Problems";
import { Process } from "@/components/landing/Process";
import { Reviews } from "@/components/landing/Reviews";
import { Calculator } from "@/components/landing/Calculator";
import { Contact } from "@/components/landing/Contact";
import { WorkshopMap } from "@/components/landing/WorkshopMap";
import { scrollToId } from "@/components/landing/shared";

export default function Home() {
  const location = useLocation();

  // When arriving from another page with a target section, scroll to it after mount.
  // Lenis caches the previous (shorter) page's scroll limit, so we must force a
  // resize + wait for paint before scrolling, otherwise the target gets clamped.
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    let cancelled = false;
    const t = setTimeout(() => {
      if (cancelled) return;
      window.__lenis?.resize();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (cancelled) return;
          window.__lenis?.resize();
          scrollToId(target);
        });
      });
    }, 220);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [location.state]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <SpecialOffer />
      <Services />
      <WhyAFZ />
      <SlowPC />
      <ScreenRepair />
      <Upgrades />
      <Extras />
      <RefurbishedStock />
      <Malware />
      <Problems />
      <Process />
      <Reviews />
      <Calculator />
      <Contact />
      <WorkshopMap />
    </main>
  );
}
